import { Heading } from 'blaze-ui/Heading/Heading'
import Styles from './Cta.module.scss'

import { Modal } from 'almanac-ui/Modal'
import { Button } from 'blaze-ui/Button'
import { ColumnVertical1, Send1, Target2, TemplatesFilled, UsersProfiles1 } from 'blaze-ui/icons'
import Server02 from 'blaze-ui/icons/16/Server02'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'
import { Text } from 'blaze-ui/Text/Text'

export const Cta = ({
  onCancel,
  onConfirm,
  isTrialing,
  onUpgradeToGrowth,
}: {
  onCancel: () => void
  onConfirm: () => void
  isTrialing: boolean
  onUpgradeToGrowth: () => void
}) => {
  const isSystemRedesignEnabled = useIsSystemRedesign()

  return (
    <Modal.Content className={Styles.modalContent}>
      <div className={Styles.container}>
        <div className={Styles.leftSection}>
          <div className={Styles.contentWrapper}>
            <div className={Styles.content}>
              <Heading level={1}>Upgrade to Growth to unlock full access</Heading>
              <div className={Styles.features}>
                <Heading level={5}>
                  {isSystemRedesignEnabled ? 'Scale your marketing without limits:' : 'Upgrade and unlock:'}
                </Heading>
                <div className={Styles.feature}>
                  <Send1 color="var(--blue-50)" size={24} />
                  {isSystemRedesignEnabled ? (
                    <Text>Unlimited posting & cross-posting</Text>
                  ) : (
                    <Heading level={4}>Unlimited posting & cross-posting</Heading>
                  )}
                </div>
                <div className={Styles.feature}>
                  <TemplatesFilled color="var(--blue-50)" size={24} />
                  {isSystemRedesignEnabled ? (
                    <Text>Unlimited posting channels</Text>
                  ) : (
                    <Heading level={4}>Unlimited posting channels</Heading>
                  )}
                </div>
                <div className={Styles.feature}>
                  <UsersProfiles1 color="var(--blue-50)" size={24} />
                  {isSystemRedesignEnabled ? (
                    <Text>Unlimited seats and multi-user workflow</Text>
                  ) : (
                    <Heading level={4}>Unlimited seats and multi-user workflow</Heading>
                  )}
                </div>
                <div className={Styles.feature}>
                  <ColumnVertical1 color="var(--blue-50)" size={24} />
                  {isSystemRedesignEnabled ? (
                    <Text>Parallel campaigns</Text>
                  ) : (
                    <Heading level={4}>Parallel campaigns</Heading>
                  )}
                </div>
                <div className={Styles.feature}>
                  <Target2 color="var(--blue-50)" size={24} />
                  {isSystemRedesignEnabled ? (
                    <Text>AI ad management</Text>
                  ) : (
                    <Heading level={4}>AI ad management</Heading>
                  )}
                </div>
                <div className={Styles.feature}>
                  <Server02 size={24} color="var(--blue-50)" />
                  {isSystemRedesignEnabled ? (
                    <Text>1200 generation credits</Text>
                  ) : (
                    <Heading level={4}>1200 generation credits</Heading>
                  )}
                </div>
              </div>
              {isSystemRedesignEnabled && (
                <Button fullWidth onPress={onUpgradeToGrowth} size="xl">
                  Continue with Growth Plan
                </Button>
              )}
            </div>
          </div>
          <div className={Styles.footer}>
            <Button variant="tertiary" onPress={onCancel} size={isSystemRedesignEnabled ? 'lg' : 'md'}>
              Close
            </Button>
            <div className={Styles.right}>
              <Button variant="tertiary" onPress={onConfirm} size={isSystemRedesignEnabled ? 'lg' : 'md'}>
                See All Plans
              </Button>
              {!isSystemRedesignEnabled && <Button onPress={onUpgradeToGrowth}>Upgrade to Growth</Button>}
            </div>
          </div>
        </div>
        <div className={Styles.rightSection}></div>
      </div>
    </Modal.Content>
  )
}
